import { post } from 'util/fetch';

export const errorLogging = (errorInfo, signal) => post('/client-api/logging/error', { body: errorInfo, signal });
